<fe-header style="z-index: 10000"></fe-header>
<fe-href-subheader [breadcrumbs]="breadcrumbs"></fe-href-subheader>

<main class="coverages">
    <section class="coverages__hero">
        <div class="container-xl coverages__hero-inner">
            <div class="coverages__hero-copy">
                <p class="coverages__badge">
                    {{ 'fe_coverages_hero_badge' | translate }}
                </p>
                <h1 class="coverages__hero-title">
                    {{ 'fe_coverages_hero_title' | translate }}
                </h1>
                <p class="coverages__hero-subtitle">
                    {{ 'fe_coverages_hero_subtitle' | translate }}
                </p>
            </div>
            <aside class="coverages__note">
                <p class="coverages__note-title">
                    {{ 'fe_coverages_hero_note_title' | translate }}
                </p>
                <p class="coverages__note-text">
                    {{ 'fe_coverages_hero_note_text' | translate }}
                </p>
            </aside>
        </div>
    </section>

    <section class="container-xl coverages__section">
        <div class="coverages__intro">
            <div>
                <h2 class="coverages__title">
                    {{ 'fe_coverages_intro_title' | translate }}
                </h2>
                <p class="coverages__text">
                    {{ 'fe_coverages_intro_paragraph_one' | translate }}
                </p>
                <p class="coverages__text mb-0">
                    {{ 'fe_coverages_intro_paragraph_two' | translate }}
                </p>
            </div>
            <div class="coverages__summary">
                <h3 class="coverages__summary-title">
                    {{ 'fe_coverages_summary_title' | translate }}
                </h3>
                <ul class="coverages__summary-list">
                    <li *ngFor="let key of summaryKeys">
                        <ng-container
                            *ngTemplateOutlet="checkIcon"
                        ></ng-container>
                        <span>{{ key | translate }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </section>

    <section class="container-xl coverages__section">
        <h2 class="coverages__title">
            {{ 'fe_coverages_levels_title' | translate }}
        </h2>
        <p class="coverages__text">
            {{
                'fe_details_step3_protection_level_protection_title_subtitle'
                    | translate
            }}
        </p>

        <ul class="coverages__levels" *ngIf="hasInsurances; else staticLevels">
            <li class="coverages__card" *ngFor="let insurance of insurances">
                <img
                    class="coverages__card-icon"
                    [src]="getIcon(insurance) | cdn"
                    alt=""
                    width="56"
                    height="56"
                />
                <h3 class="coverages__card-name">
                    {{ insurance.title }}
                </h3>
                <p
                    class="coverages__card-tagline"
                    *ngIf="getTaglineKey(insurance) as taglineKey"
                >
                    {{ taglineKey | translate }}
                </p>
                <ul class="coverages__card-features">
                    <li *ngFor="let feature of getFeatures(insurance)">
                        <ng-container
                            *ngTemplateOutlet="checkIcon"
                        ></ng-container>
                        <span>{{ feature }}</span>
                    </li>
                </ul>
            </li>
        </ul>

        <ng-template #staticLevels>
            <ul class="coverages__levels">
                <li class="coverages__card" *ngFor="let level of levels">
                    <img
                        class="coverages__card-icon"
                        [src]="level.icon | cdn"
                        alt=""
                        width="56"
                        height="56"
                    />
                    <h3 class="coverages__card-name">
                        {{ level.nameKey | translate }}
                    </h3>
                    <p class="coverages__card-tagline">
                        {{ level.taglineKey | translate }}
                    </p>
                    <ul class="coverages__card-features">
                        <li *ngFor="let feature of level.featureKeys">
                            <ng-container
                                *ngTemplateOutlet="checkIcon"
                            ></ng-container>
                            <span>{{ feature | translate }}</span>
                        </li>
                    </ul>
                </li>
            </ul>
        </ng-template>
    </section>

    <section class="container-xl coverages__section" id="coverages-table">
        <h2 class="coverages__title">
            {{ 'fe_coverages_table_title' | translate }}
        </h2>
        <p class="coverages__text">
            {{ 'fe_coverages_table_subtitle' | translate }}
        </p>

        <div class="coverages__table-wrapper">
            <table class="coverages__table">
                <caption class="visually-hidden">
                    {{
                        'fe_coverages_table_caption' | translate
                    }}
                </caption>
                <thead>
                    <tr>
                        <th scope="col">
                            {{ 'fe_coverages_table_column' | translate }}
                        </th>
                        <th scope="col" *ngFor="let level of levels">
                            {{ level.nameKey | translate }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of coverages">
                        <th scope="row">
                            <span class="coverages__table-name">{{
                                row.nameKey | translate
                            }}</span>
                            <span
                                class="coverages__table-hint"
                                *ngIf="row.hintKey"
                                >{{ row.hintKey | translate }}</span
                            >
                        </th>
                        <td *ngFor="let level of levels">
                            <span
                                class="coverages__table-note"
                                *ngIf="noteKey(row, level) as note"
                                >{{ note | translate }}</span
                            >
                            <ng-container *ngIf="showCheck(row, level)">
                                <ng-container
                                    *ngTemplateOutlet="checkIcon"
                                ></ng-container>
                                <span class="visually-hidden">{{
                                    'fe_coverages_table_included' | translate
                                }}</span>
                            </ng-container>
                            <ng-container *ngIf="!isIncluded(row, level)">
                                <span
                                    class="coverages__table-dash"
                                    aria-hidden="true"
                                ></span>
                                <span class="visually-hidden">{{
                                    'fe_coverages_table_not_included'
                                        | translate
                                }}</span>
                            </ng-container>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <p class="coverages__footnote">
            {{ 'fe_coverages_table_note' | translate }}
        </p>
    </section>

    <section class="container-xl coverages__section">
        <div class="coverages__deposit">
            <h2 class="coverages__title">
                {{ 'fe_coverages_deposit_title' | translate }}
            </h2>

            <div class="coverages__callout">
                <img
                    class="coverages__callout-icon"
                    [src]="'images/insurance-premium.svg' | cdn"
                    alt=""
                    width="40"
                    height="40"
                />
                <div>
                    <h3 class="coverages__callout-title">
                        {{ 'fe_coverages_deposit_callout_title' | translate }}
                    </h3>
                    <p class="coverages__text mb-0">
                        {{ 'fe_coverages_deposit_callout_text' | translate }}
                    </p>
                </div>
            </div>

            <p class="coverages__text">
                {{ 'fe_coverages_deposit_paragraph' | translate }}
            </p>

            <ul class="coverages__amounts">
                <li class="coverages__amount" *ngFor="let level of levels">
                    <span class="coverages__amount-name">{{
                        level.nameKey | translate
                    }}</span>
                    <strong class="coverages__amount-value">{{
                        level.depositKey | translate
                    }}</strong>
                </li>
            </ul>
        </div>
    </section>
</main>

<fe-footer></fe-footer>

<ng-template #checkIcon>
    <svg
        class="coverages__check"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
    >
        <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
</ng-template>
